import { size, sum, uniq, zipWith } from 'lodash'

import regex from 'helpers/regex'

const FIRST_CHECK_DIGIT_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const SECOND_CHECK_DIGIT_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

// CNPJ com todos os 14 caracteres repetidos é formalmente válido no cálculo, mas nunca é emitido
const isAllCharactersRepeated = (value) => size(uniq(value.split(''))) === 1

// charCodeAt(0) - 48 dá o valor numérico tanto de dígitos ('0'-'9') quanto de letras
// ('A'-'Z', ASCII 65-90 => 17-42), conforme IN RFB 2.229/2024 para o CNPJ alfanumérico
const calculateCheckDigit = (characters, weights) => {
  const weightedValues = zipWith(
    characters.split(''),
    weights,
    (character, weight) => (character.charCodeAt(0) - 48) * weight,
  )

  const remainder = sum(weightedValues) % 11
  return remainder < 2 ? 0 : 11 - remainder
}

const isValid = (value) => {
  const sanitizedValue = regex.onlyNumbersAndLetters(value || '')

  if (size(sanitizedValue) !== 14 || isAllCharactersRepeated(sanitizedValue))
    return false

  const baseCharacters = sanitizedValue.slice(0, 12)
  const informedCheckDigits = sanitizedValue.slice(12)

  const firstCheckDigit = calculateCheckDigit(
    baseCharacters,
    FIRST_CHECK_DIGIT_WEIGHTS,
  )
  const secondCheckDigit = calculateCheckDigit(
    baseCharacters + firstCheckDigit,
    SECOND_CHECK_DIGIT_WEIGHTS,
  )

  return informedCheckDigits === `${firstCheckDigit}${secondCheckDigit}`
}

export default { isValid }
